<template>
  <div id="empty">
    <section class="app-body">
      <transition name="fade" mode="out-in">
        <router-view/>
      </transition>
    </section>
  </div>
</template>

<script>
export default {
  name: 'empty'
}
</script>
